import React from 'react';

export const BackupItemIcon = (props) => (
    <svg {...props} viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 0C13.8 0 10.2 2.6 8.7 6.2C8.2 6.1 7.6 6 7 6C3.1 6 0 9.1 0 13C0 16.9 3.1 20 7 20C8.9 20 15.7 20 18 20L14 15H16.5V8H19.5V15H22L18 20C23.5 20 28 15.5 28 10C28 4.5 23.5 0 18 0Z" />
    </svg>
);

export default BackupItemIcon;
